import { render, staticRenderFns } from "./DialogProject.vue?vue&type=template&id=fcf323b4&scoped=true"
import script from "./DialogProject.vue?vue&type=script&lang=js"
export * from "./DialogProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf323b4",
  null
  
)

export default component.exports